/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const billingProfileListDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.string(),
			stripeCustomerId: z.string(),
			name: z.string().nullable(),
			email: z.string().nullable(),
			address: z.object({
				line1: z.string().nullable(),
				line2: z.string().nullable(),
				city: z.string().nullable(),
				state: z.string().nullable(),
				postalCode: z.string().nullable(),
				country: z.string().nullable(),
			}).nullable(),
			locale: z.union([z.literal('en-GB'), z.literal('de-DE'), z.literal('fi-FI')]),
			taxIds: z.array(
				z.object({
					type: z.string(),
					value: z.string(),
					verification: z.union([
						z.literal('pending'),
						z.literal('unavailable'),
						z.literal('unverified'),
						z.literal('verified'),
					]),
				}),
			),
			archived: z.boolean(),
			isPrimary: z.boolean(),
			fundingInstructions: z.array(
				z.object({ accountHolder: z.string(), iban: z.string(), bic: z.string(), country: z.string() }),
			),
			preferredPaymentMethod: z.union([z.literal('stripe'), z.literal('invoice')]),
		}),
	),
	billingEntity: z.object({ id: z.string(), name: z.string(), country: z.string() }).nullable(),
})

export type BillingProfileListDataSchema = z.infer<typeof billingProfileListDataSchema>
